<template>
    <div class="VnoOpenCard">

        <!-- v-if="JudgePhoneFlag == 'android'" -->
        <div class="VnoOpenCards" v-if="JudgePhoneFlag == 'android'">

            <div class="OpenCard_header">
                <div class="OpenCard_header_title">
                    <p>开卡</p>
                </div>
                <StepsData :active="active" :Iphone="Iphone" :wholetcard="wholetcard" />
            </div>

            <div class="one" v-if="active == 0">
                <div class="one_header">
                    <div class="one_header_tit">
                        <div class="tu">
                            <img src="~@/assets/images/opencard/open1.png" alt="" />
                        </div>
                        <div>填写开卡信息</div>
                    </div>
                    <div class="stepNumber">1/4</div>
                </div>
                <TypeNumber :condition="condition" :Iphone="Iphone" ref="openCardForm" :wholetcard="wholetcard"
                    :sparePhone="sparePhone" @form-change="onFormChange" />
                <IpLocation ref="ipLocation" />
            </div>

            <div class="two" v-if="active == 1">
                <div class="one_header">
                    <div class="one_header_tit">
                        <div class="tu">
                            <img src="~@/assets/images/opencard/open3.png" alt="" />
                        </div>
                        <div>默认套餐</div>
                    </div>
                    <div class="stepNumber">2/4</div>
                </div>

                <div class="two_content" v-for="item, index in ComboLists" :key="index">
                    <div class="two_header_tit" v-if="index == 1">
                        <div class="tu">
                            <img src="~@/assets/images/opencard/open3.png" alt="" />
                        </div>
                        <span>可变更套餐</span>
                    </div>

                    <div class="two_content_url_li" :class="{ rechar_active: rechar_li == index }"
                        @click="rechar(item, index)">
                        <div class="two_con_left">
                            <div class="two_con_left_tit">
                                {{ item.prodOfferName }}
                            </div>
                            <div class="two_con_left_con">
                                <p class="particularsData" v-html="item.prodofferdesc"></p>
                            </div>
                        </div>

                        <div class="two_con_right">
                            <div class="two_con_right_price">
                                <span>￥{{ item.sumFee }}</span>
                            </div>
                            <div class="two_con_right_details">
                                <p @click="TwoDetailsShow = true">查看详情</p>
                            </div>

                        </div>
                    </div>

                </div>
                <van-popup v-model="TwoDetailsShow" :style="{ width: '90%', height: '30%' }">
                    <div class="wrapper">
                        <div @click.stop class="block">
                            <div class="block_tit">
                                <span>套餐详情</span>
                            </div>
                            <p class="close" @click="TwoDetailsShow = false">X</p>
                            <p class="block_con" v-html="prodofferdesc"></p>
                        </div>
                    </div>
                </van-popup>
            </div>

            <div class="three" v-if="active == 2">
                <div class="one_header">
                    <div class="one_header_tit">
                        <div class="tu">
                            <img src="~@/assets/images/opencard/open4.png" alt="" />
                        </div>
                        <span>入网协议</span>
                    </div>
                    <div class="yenum">3/4</div>
                </div>
                <Four @imgBase64Data="onSignChange" @checked-change="onCheckedChange" @read_all="handleReadAll" />
            </div>

            <!-- 拍照开始 -->
            <div v-if="active == 3">
                <Three class="five" @ImgsBase64Data="ImgsBase64"></Three>
            </div>
            <!-- 拍照结束 -->

            <div class="four" v-if="active == 4">
                <div class="one_header">
                    <div class="one_header_tit">
                        <div class="tu">
                            <img src="~@/assets/images/opencard/open2.png" alt="" />
                        </div>
                        <div>实名认证</div>
                    </div>
                    <div class="stepNumber">3/4</div>
                </div>
                <!-- v-if="ifCheckCard == '0'" -->
                <div class="three_goautonym" @click="goautonym">
                    <img src="~@/assets/images/opencard/open5.png" alt="" />
                </div>
            </div>

            <div class="OpenCard_footer">
                <button @click="NextStep">
                    {{ active == 4 ? "去实名" : "下一步" }}
                </button>
            </div>
        </div>

        <div class="login_tu" v-if="JudgePhoneFlag == 'micromessenger'">
            <p>点击右上角在浏览器中打开</p>
        </div>

        <div class="login_tus" v-if="JudgePhoneFlag == 'unknown'">
            <p>该系统暂不支持开卡</p>
        </div>

    </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import preventBack from "vue-prevent-browser-back"
import { getUrlKey } from '../../common/utils/router'
import Four from "../../components/openCard/four.vue"
import Three from "../../components/openCard/three.vue"
import IpLocation from "../../components/IpLocation.vue"
import { GetPhoneById } from "../../common/newapi/ghsm_api"
import {
    SimOrServiceIdQuery, CheckIccid, QueryOpenCardLocation,
    CheckPhoneValid, ChanelCheck, AppCommonCheck, Checkoffername,
    AddOpenCardLocation, SignatureUpload, GetBossUrl,
    GetSimpleOrCardNum, DoCheckIdentityCodeByWorkNo,
    QuerySign, Dosubmits, UploadCard, GetSeesion, Checkworknoinfo
} from "../../common/newapi/api.js"
import TypeNumber from '../../components/openCard/TypeNumber.vue'
import StepsData from '../../components/openCard/openCardSteps.vue'
import OpenCardParamsMixin from '../../components/openCard/OpenCardParamsMixin.js';
export default {
    components: {
        Four, Three, IpLocation, StepsData, TypeNumber
    },
    mixins: [preventBack, OpenCardParamsMixin], //注入  阻止返回上一页
    data() {
        return {
            active: "0", //流程进度
            Iphone: "", //用户输入的手机号
            wholetcard: "", //用户输入的的后七位iccid号码
            FullCard: "", //完整的卡号
            sparePhone: "", //联系人手机号
            prodOfferName: "", //套餐名称
            sumFee: "", //套餐价格
            judge: false, //实名认证完成返回页面的变量
            //入网协议数据
            imgsData: "", //电子签名照片数据
            isReadAll: false, //入网协议是否已读
            CheckedState: false, //入网协议选中状态
            canvas: 1, //判断是否执行画布
            sign: "", //提交加密接口的加密串
            timestamp: "", //提交加密接口的时间戳
            payNum: false, //支付查询的开关 000开始查询
            // 是否增加小卡版数据
            TogetherImgsFlag: "wu", //用户合拍显示隐藏
            TogetherImgsData: "", //合拍base64码
            ifCheckCard: "", //实名认证背景图是否添加小卡版显示隐藏
            // 接口数据
            SimOrServiceIdQueryDatas: {}, //号卡查询接口的数据
            checkphonevaliddata: {}, //号卡有效性验证的数据
            ProdOfferData: {}, //获取的默认套餐页面数据
            QueryOne: {}, //第一次查询开卡记录的数据
            // 接口数据结束

            VnoUrlRecordNumber: "", //url获取的订单号
            JudgePhoneFlag: null,   //在浏览器中打开
            GetPhoneByIdData: {},   //订单号查手机号接口数据
            CheckworknoinfoData: {}, //工号登录信息查询数据

            ProdOfferData: {}, //固定套餐
            modifiable: [],  //可变更套餐
            ComboList: [],//所有套餐
            TwoDetailsShow: false,//查看套餐详情
            TwoChangeShow: false,//查看可更改套餐详情
            rechar_li: 0,//选择套餐
            cityCode: "", //城市信息
            condition: null, // 默认值
        }
    },

    created() {
        // pc免登录链接跳转过来的
        if (this.$route.query.title) {
            this.condition = 1
            this.JudgePhoneFlag = "android"
            this.GainTokenData() //获取免登录token
        }
        // pc二维码开卡链接
        if (this.$route.query.pone) {
            this.condition = 2
            this.judgePhone()  //判断是否为微信内置浏览器中打开
        }
        this.wxPayQuery() //支付查询
        this.authentication()   //实名认证查询
    },
    // 组件方法
    methods: {
        //选择套餐
        rechar(item, index) {
            this.rechar_li = index
            this.prodOfferName = item.prodOfferName
            this.sumFee = item.sumFee
            this.prodofferdesc = item.prodofferdesc
            this.ProdOfferData = item
        },

        //判断是否为微信内置浏览器中打开
        judgePhone() {
            let ua = window.navigator.userAgent.toLowerCase()
            const isAndroid = ua.includes("android");
            const isIOS = ua.includes("iphone os");
            const isWeChat = ua.includes("micromessenger");

            if (isAndroid || isIOS) {
                // 判断是否在微信浏览器中打开
                this.JudgePhoneFlag = isWeChat ? "micromessenger" : "android";
                if (!isWeChat) {
                    this.GainUrlData();
                }
            } else {
                alert("该系统暂不支持开卡");
                this.JudgePhoneFlag = "unknown";
            }
        },

        // 获取url订单号
        async GainUrlData() {
            let pone = getUrlKey('pone');
            if (!pone) {
                this.showToast("数据缺失,请重新扫码！");
                return;
            }
            this.VnoUrlRecordNumber = pone;

            // 通过订单号查询的手机号
            try {
                const phonedata = await GetPhoneById({ id: this.VnoUrlRecordNumber });
                if (phonedata.code !== 1) {
                    this.showToast(phonedata.msg);
                    console.error("GetPhoneById 错误:", phonedata);
                    return;
                }

                this.GetPhoneByIdData = phonedata.data;
                this.Iphone = phonedata.data.serviceId; // 获取手机号
                this.wholetcard = phonedata.data.cardNo.slice(-7); // 获取卡号后七位

                // 获取 token
                const TokenData = await GetSeesion({
                    workNo: phonedata.data.loginName,
                    Type: "0",
                });

                if (TokenData.code !== 1) {
                    this.showToast(TokenData.msg);
                    return;
                }

                localStorage.setItem("tokens", TokenData.data.thirdSession);
                localStorage.setItem("workNo", TokenData.data.workNo);
            } catch (error) {
                console.error("接口调用失败:", error.message || error);
                this.showToast("获取数据失败，请稍后重试！");
            }
        },

        // 获取pc免登录token
        async GainTokenData() {
            let titData = getUrlKey('title')
            if (titData) {
                // pc免登录登录成功做的操作
                this.GetPhoneByIdData = JSON.parse(localStorage.getItem("Userdata"))
            } else {
                this.showToast("数据缺失,请重新打开链接！");

            }
        },

        // 获取用户输入信息
        onFormChange(form) {
            this.Iphone = form.Iphone
            this.wholetcard = form.wholetcard
            this.sparePhone = form.sparePhone
        },

        // 点击下一步操作
        async NextStep() {
            // 第一页
            if (this.active == 0) {
                const verifyResult = this.$refs.openCardForm.validateForm()
                if (!verifyResult.valid) {
                    this.showToast(verifyResult.message);
                    return;
                } else {
                    // 获取IP信息
                    try {
                        const ip = await this.$refs.ipLocation.fetchLocation();
                        console.log("从 IpLocation 获取的 IP 地址:", ip);
                        this.cityCode = ip; // 将获取的城市信息赋值给 cityCode
                    } catch (error) {
                        console.error("获取 IP 地址失败:", error);
                        this.cityCode = "360"; // 默认值
                    }

                    // 号码查询
                    try {
                        var SimOrServiceIdQueryData = await SimOrServiceIdQuery({
                            iccidOrServiceId: this.Iphone,
                            sparePhone: this.sparePhone, //用户输入的联系方式
                            type: 2,
                        })
                    } catch (err) {
                        this.showToast("号码查询失败");
                    }
                    if (SimOrServiceIdQueryData.code != "0000") {
                        this.showToast(SimOrServiceIdQueryData.msg);
                    }
                    else {
                        this.SimOrServiceIdQueryDatas = SimOrServiceIdQueryData  //号码查询接口的所有值赋值到SimOrServiceIdQueryDatas

                        localStorage.setItem("uimId", this.SimOrServiceIdQueryDatas.cardNo)   //将卡号添加至本地缓存


                        //首次查询开卡记录(判断首次有没有开卡流程)
                        var QueryOpenCardData = await QueryOpenCardLocation({
                            uimId: this.SimOrServiceIdQueryDatas.cardNo,
                        })
                        this.QueryOne = QueryOpenCardData.data
                        this.QueryOne = QueryOpenCardData.data

                        // 有开卡进程
                        if (QueryOpenCardData.code == 1) {
                            if (QueryOpenCardData.data.openCardLocation == 1) {
                                // 套餐名称及价格赋值渲染
                                this.prodOfferName = QueryOpenCardData.data.prodOfferName
                                this.sumFee = QueryOpenCardData.data.sumFee

                                // 通过判断rechargeAmount(充值金额)跟rechargeFlag[(支付标记)start为没有充值，finish为已充值成功]
                                // 充值金额大于0 与 支付标记为finish时为充值成功
                                const { sumFee, rechargeFlag, openCardLocation } = QueryOpenCardData.data;
                                if (sumFee > 0) {
                                    if (rechargeFlag === "start") {
                                        // 有充值但未支付成功，跳转支付页
                                        this.$router.push("/OpenPay");
                                        return;
                                    }
                                    // 已充值成功，跳转到对应步骤
                                    this.active = openCardLocation;
                                } else {
                                    // 套餐价格为0，直接跳转到入网协议
                                    this.active = 2;
                                }
                            }
                            // 步骤条进度等于2
                            else if (QueryOpenCardData.data.openCardLocation == 2) {
                                this.ifCheckCard = this.QueryOne.ifCheckCard //是否显示小卡版赋值
                                this.active = QueryOpenCardData.data.openCardLocation //跳转相应页面
                            }
                            // 步骤条进度等于3
                            else if (QueryOpenCardData.data.openCardLocation == 3) {
                                this.ifCheckCard = this.QueryOne.ifCheckCard //是否显示小卡版赋值
                                // 判断是否需要小卡板合拍 1：合拍跳转合拍页 0：不用合拍跳转实名页
                                this.QueryOne.ifCheckCard == 1 ? this.active = 3 : this.active = 4
                                this.active = QueryOpenCardData.data.openCardLocation // 直接跳转到存储的页面中
                            }
                            // 步骤条进度等于4
                            else if (QueryOpenCardData.data.openCardLocation == 4) {
                                this.ifCheckCard = this.QueryOne.ifCheckCard //是否显示小卡版赋值
                                this.active = QueryOpenCardData.data.openCardLocation // 直接跳转到存储的页面中
                            } else {
                                console.log("开卡流程缺失")
                            }
                            //
                        } else {
                            // 没有开过卡就正常流程

                            // 卡号后七位校验
                            let CheckIccidData = await CheckIccid({
                                serviceId: this.Iphone,
                                iccid: this.wholetcard,
                            })
                            if (CheckIccidData.code != 1) {
                                this.showToast(CheckIccidData.msg);
                            } else {
                                // 工号登录信息查询接口
                                let CheckworknoinfoData = await Checkworknoinfo({
                                    workNo: localStorage.getItem("workNo"),
                                    type: "1", //1:工号; 2:手机号
                                })

                                if (CheckworknoinfoData.code == -100) {
                                    this.showToast(CheckworknoinfoData.msg);
                                } else {
                                    this.CheckworknoinfoData = CheckworknoinfoData.data
                                    //号卡有效性验证接口
                                    var CheckPhoneValidData = await CheckPhoneValid(
                                        {
                                            serviceId: this.Iphone, //用户输入的手机号
                                            uimId: this.GetPhoneByIdData.cardNo ? this.GetPhoneByIdData.cardNo : SimOrServiceIdQueryData.cardNo, //完整iccid
                                            workNo: this.GetPhoneByIdData.loginName ? this.GetPhoneByIdData.loginName : this.GetPhoneByIdData.workNo,
                                            appType: CheckworknoinfoData.data.dealerName,
                                        }
                                    )
                                    if (CheckPhoneValidData.code != 0) {
                                        this.showToast(CheckPhoneValidData.msg);
                                    }
                                    else {
                                        this.checkphonevaliddata = CheckPhoneValidData.data
                                        //渠道校验接口
                                        var ChanelCheckData = await ChanelCheck({
                                            serviceId: this.Iphone, //用户输入的手机号
                                            workNo: localStorage.getItem("workNo"),
                                        })

                                        if (ChanelCheckData.code != 0) {
                                            this.showToast(ChanelCheckData.msg);
                                        }
                                        else {
                                            //激活期和冻结接口
                                            var AppCommonCheckData = await AppCommonCheck({
                                                serviceId: this.Iphone, //用户输入的手机号
                                                workNo: localStorage.getItem("workNo"),
                                            })

                                            if (AppCommonCheckData.code != 0) {
                                                this.showToast(AppCommonCheckData.msg);
                                            }
                                            else {
                                                //未激活号码套餐展示 不可变更套餐查询
                                                var CheckoffernameData2 = await Checkoffername({
                                                    WorkNo: localStorage.getItem("workNo"),
                                                    serviceId: this.Iphone, //用户输入的手机号
                                                    iccId: this.SimOrServiceIdQueryDatas.cardNo, //用户输入的iccid
                                                    type: 2, //查询类型 1可变 2 固定
                                                    SystemId: 1, //来源类型
                                                })
                                                if (CheckoffernameData2.code == 1) {
                                                    let SetMealListData = []
                                                    SetMealListData.push(CheckoffernameData2.data)
                                                    //未激活号码套餐展示 可变更套餐查询
                                                    var CheckoffernameData1 = await Checkoffername({
                                                        WorkNo: localStorage.getItem("workNo"),
                                                        serviceId: this.Iphone, //用户输入的手机号
                                                        iccId: this.SimOrServiceIdQueryDatas.cardNo, //用户输入的iccid
                                                        type: 1, //查询类型 1可变 2 固定
                                                        SystemId: 1, //来源类型
                                                    })
                                                    if (CheckoffernameData1.code == 1) {
                                                        this.ComboList = SetMealListData.concat(CheckoffernameData1.data)
                                                        this.ComboList.forEach((item) => {
                                                            item.prodofferdesc = item.prodofferdesc.replace(/\<ul/gi, "<ul style='list-style:none;margin:0px;padding:0px;'")
                                                        })
                                                    } else {
                                                        //无可变更套餐
                                                        this.ComboList = SetMealListData
                                                        this.ComboList.forEach((item) => {
                                                            if (item.prodofferdesc) {
                                                                item.prodofferdesc = item.prodofferdesc.replace(/\<ul/gi, "<ul style='list-style:none;margin:0px;padding:0px;'")
                                                            }
                                                        })
                                                    }
                                                    this.ComboLists = this.ComboList
                                                    this.prodofferdesc = this.ComboList[0]
                                                    this.active = 1
                                                    this.ProdOfferData = this.prodofferdesc
                                                } else {
                                                    Dialog.alert({
                                                        message: "获取套餐异常，请联系管理员！",
                                                    }).then(() => {
                                                        this.active = 0
                                                    })
                                                }
                                            }
                                        }
                                    }
                                }


                            }
                        }
                    }
                }
            } // 第二页
            else if (this.active == 1) {
                // 1、支付前增加缓存记录，价格大于0去支付，否则下一个页面
                let AddOpenCardOnePay = await AddOpenCardLocation({
                    applyEvent: "1", //业务类型
                    belongCode: "360", //号码归属地
                    cityCode: this.cityCode, //受理人所在地市
                    uimId: this.checkphonevaliddata.uimId,      //卡号
                    prodOfferId: this.ProdOfferData.prodOfferId, //套餐ID
                    dealerId: this.CheckworknoinfoData.dealerId, //代理商编号
                    acceptPerson: this.GetPhoneByIdData.loginName ? this.GetPhoneByIdData.loginName : this.GetPhoneByIdData.workNo,    //工号
                    ifCheckCard: this.ProdOfferData.ifCheckCard, //是否添加小卡版
                    uimResInstId: this.checkphonevaliddata.uimInstId, //卡号的实例ID
                    serviceId: this.SimOrServiceIdQueryDatas.phoneNum, //手机号
                    resInstId: this.checkphonevaliddata.serviceInstId, //号码的实例ID
                    serviceKind: this.checkphonevaliddata.serviceKind, //运营商类型
                    dealerMainId: this.CheckworknoinfoData.dealerMainId, //顶级渠道
                    recordNumber: this.SimOrServiceIdQueryDatas.recordNumber, //订单号
                    openCardLocation: this.ProdOfferData.sumFee > 0 ? "1" : "2", //步骤条进度
                    rechargeFlag: this.ProdOfferData.sumFee > 0 ? "start" : "nopay", //充值标记 start进入支付 finish支付成功 nopay不支付
                    sumFee: this.ProdOfferData.sumFee > 0 ? this.ProdOfferData.sumFee : "", //充值金额(不同)
                    PayBackUrl: "/VnoOpenCard", //支付返回地址
                })
                if (AddOpenCardOnePay.code != 1) {
                    Dialog.alert({
                        message: "缓存记录失败,请关闭链接重新扫码开卡！",
                    }).then(() => {
                        this.active = 0
                    })
                } else {
                    // 
                    if (this.ProdOfferData.sumFee > 0) {
                        localStorage.setItem("PayBackUrl", "/VnoOpenCard")
                        this.$router.push("/OpenPay")
                    } else {
                        this.active = 2
                    }
                }
            }
            // 第三页
            else if (this.active == 2) {
                if (!this.isReadAll) {
                    this.showToast("请完整看完《蓝猫移动入网协议》");
                } else if (this.CheckedState == false) {
                    this.showToast("请您阅读并同意《蓝猫移动入网协议》");
                } else if (this.imgsData == "") {
                    this.showToast("电子签名不能为空");
                } else {
                    //上传签名查询开卡记录
                    let QueryOpenCardLocationData = await QueryOpenCardLocation(
                        {
                            uimId: localStorage.getItem("uimId"),
                        }
                    )
                    if (QueryOpenCardLocationData.code != 1) {
                        Dialog.alert({
                            message: "开卡时间过长数据缺失,请重新输入手机号",
                        }).then(() => {
                            this.active = 0
                        })
                    } else {
                        // 上传签名接口)
                        let SignatureUploadData = await UploadCard({
                            image: this.imgsData, //签名图片路径
                        })

                        if (SignatureUploadData.code != 1) {
                            this.showToast(SignatureUploadData.msg);
                        }
                        else {
                            // 4、签名后增加缓存记录（入网协议增加缓存记录）)
                            let CheckCard = QueryOpenCardLocationData.data.ifCheckCard
                            let params = this.getOpenCardLocationParams(QueryOpenCardLocationData.data);
                            var AddOpenCardLocationTwo = await AddOpenCardLocation({
                                ...params,
                                // 新增
                                netSignUrl: SignatureUploadData.data, //签名图片地址
                                openCardLocation: CheckCard == 0 ? "4" : "3", //步骤条进度
                            })

                            if (AddOpenCardLocationTwo.code != 1) {
                                Dialog.alert({
                                    message: "缓存记录失败,请重新进行开卡",
                                }).then(() => {
                                    this.active = 0
                                })
                            } else {
                                this.ifCheckCard = QueryOpenCardLocationData.data.ifCheckCard
                                // 是否添加小卡板为0时，不用合拍跳转实名；1：需要合拍跳转合拍页
                                this.ifCheckCard != 1 ? this.active = 4 : this.active = 3
                            }
                        }
                    }
                }
            }
            // 第四页 合拍页
            else if (this.active == 3) {
                if (this.TogetherImgsData == "") {
                    this.showToast("请点击合拍图片进行拍照");
                } else {
                    // 查询开卡记录
                    let QueryOpenCardLocationData = await QueryOpenCardLocation({
                        uimId: localStorage.getItem("uimId"),
                    })
                    if (QueryOpenCardLocationData.code != 1) {
                        Dialog.alert({
                            message: "开卡时间过长数据缺失,请重新输入手机号",
                        }).then(() => {
                            this.active = 0
                        })
                    } else {
                        // 上传合拍照片
                        let SignatureUploadData = await SignatureUpload({
                            image: this.TogetherImgsData,
                            workNo: QueryOpenCardLocationData.data.acceptPerson, //工号
                        })
                        if (SignatureUploadData.code != 1) {
                            this.showToast(SignatureUploadData.msg);
                        } else {
                            // 4、拍合照增加缓存记录（入网协议增加缓存记录）
                            let params = this.getOpenCardLocationParams(QueryOpenCardLocationData.data);
                            var AddOpenCardLocationTwo = await AddOpenCardLocation({
                                ...params,
                                openCardLocation: "4", //步骤条进度
                                TogetherUrl: SignatureUploadData.data, //合拍图片地址
                                netSignUrl: QueryOpenCardLocationData.data.netSignUrl, //签名图片地址
                            })
                            if (AddOpenCardLocationTwo.code != 1) {
                                Dialog.alert({
                                    message: "缓存记录失败,请重新进行开卡",
                                }).then(() => {
                                    this.active = 0
                                })
                            } else {
                                this.ifCheckCard = QueryOpenCardLocationData.data.ifCheckCard
                                this.active = 4
                            }
                        }
                    }
                }
            }
            // 第五页 实名页
            else if (this.active == 4) {
                // 获取实名认证地址
                this.goautonym()
            }
        },

        //微信查询返回跳转入网协议操作
        async wxPayQuery() {
            if (localStorage.getItem("payquery") == "1") {
                this.JudgePhoneFlag = "android"
                var QueryOpenCardLocationData = await QueryOpenCardLocation({
                    uimId: localStorage.getItem("uimId"),
                })
                if (QueryOpenCardLocationData.code != 1) {
                    localStorage.setItem("payquery", false)
                    Dialog.alert({
                        message: "开卡时间过长数据缺失,请重新输入手机号",
                    }).then(() => {
                        this.active = 0
                    })
                } else {
                    localStorage.removeItem("payquery")
                    this.ifCheckCard = QueryOpenCardLocationData.data.ifCheckCard
                    this.active = QueryOpenCardLocationData.data.openCardLocation //是否添加小卡版及步骤条赋值
                }
            } else {
                console.log("微信认证失败")
                localStorage.setItem("payquery", false)
            }
        },

        // isReadAll 为 true，代表协议已看完
        handleReadAll(isReadAll) {
            this.isReadAll = isReadAll
        },

        // 处理签名base64
        onSignChange(imgsData) {
            this.imgsData = imgsData
        },

        // 入网协议勾选状态
        onCheckedChange(checked) {
            this.CheckedState = checked
        },


        // 获取实名认证地址
        async goautonym() {
            let QueryOpenCardLocationData = await QueryOpenCardLocation({ uimId: localStorage.getItem("uimId"), })
            if (QueryOpenCardLocationData.code != 1) {
                localStorage.setItem("payquery", false)
                Dialog.alert({
                    message: "开卡时间过长数据缺失,请重新输入手机号",
                }).then(() => {
                    this.active = 0
                })
            } else {
                let GetUrlData = await GetBossUrl({
                    returnUrl: "/VnoOpenCard",
                    serviceId: QueryOpenCardLocationData.data.serviceId,
                    recordNumber: QueryOpenCardLocationData.data.recordNumber,
                })
                if (GetUrlData.code != 1) {
                    Dialog.alert({
                        message: GetUrlData.msg,
                    }).then(() => {
                        this.active = 0
                    })
                } else {
                    localStorage.setItem("GetToken", GetUrlData.data.token)
                    localStorage.setItem("BizNo", GetUrlData.data.biz_no)
                    this.judge = "RealNameStart" //实名开卡=0需要查询
                    localStorage.setItem("Judge", this.judge) //存储开关
                    window.location.href = GetUrlData.data.url
                }
            }
        },

        // 实名认证查询
        async authentication() {
            if (localStorage.getItem("Judge") == "RealNameStart") {
                this.JudgePhoneFlag = "android"
                console.log("认证成功开始调用")
                // 开始认证查询
                this.active = 4
                // 实名后查询开卡记录
                let QueryOpenCardData = await QueryOpenCardLocation({
                    uimId: localStorage.getItem("uimId"),
                })
                if (QueryOpenCardData.code != 1) {
                    localStorage.setItem("Judge", false) //实名查询禁止
                    Dialog.alert({
                        message: "开卡时间过长数据缺失,请重新输入手机号",
                    }).then(() => {
                        localStorage.setItem("Judge", false)
                        this.active = 0
                    })
                } else {
                    this.ifCheckCard = QueryOpenCardData.data.ifCheckCard //实名认证图片展示赋值
                    try {
                        let bizId = localStorage.getItem("BizNo")
                        // 获取实名认证验证信息接口
                        let GetSimpleOrCardNumData = await GetSimpleOrCardNum({
                            bizId: bizId ? bizId : '',
                            uimId: QueryOpenCardData.data.uimId,
                            token: localStorage.getItem("GetToken"),
                            serviceId: QueryOpenCardData.data.serviceId,
                            workNo: QueryOpenCardData.data.acceptPerson,
                            recordNumber: QueryOpenCardData.data.recordNumber,
                            cityName: QueryOpenCardData.data.cityCode, // IP地势
                        })

                        if (GetSimpleOrCardNumData.code != 1) {
                            localStorage.setItem("Judge", false) //实名查询禁止
                            this.showToast(GetSimpleOrCardNumData.msg);
                        }
                        // 获取实名认证验证信息接口的否则(接口成功)
                        else {
                            if (GetSimpleOrCardNumData.data.cardNum.success == 0) {
                                if (GetSimpleOrCardNumData.data.simple.success == 0) {
                                    // 一证五户校验接口
                                    let IdentityCardVerifyData = await DoCheckIdentityCodeByWorkNo({
                                        aceptPerson: QueryOpenCardData.data.acceptPerson,
                                        identityCode: GetSimpleOrCardNumData.data.cardNum.confirmIdcardNumber,
                                    })

                                    if (IdentityCardVerifyData.code != 0) {
                                        localStorage.setItem("Judge", false) //实名查询禁止
                                        this.showToast(IdentityCardVerifyData.msg);
                                    } else {
                                        // 提交加密
                                        let QuerySignData = await QuerySign({
                                            serviceId: QueryOpenCardData.data.serviceId,
                                        })
                                        if (QuerySignData.code != 1) {
                                            localStorage.setItem("Judge", false) //实名查询禁止
                                            this.showToast(QuerySignData.msg);
                                        }
                                        // 提交加密接口否则(接口成功)
                                        else {
                                            // 判断是否充值定义变量rechargeFlag (充值标记为finish为已充值，start为)
                                            const CardOutdexData = QueryOpenCardData.data.ifCheckCard != 1
                                                ? GetSimpleOrCardNumData.data.cardNum.back
                                                : QueryOpenCardData.data.TogetherUrl;
                                            QueryOpenCardData.data.rechargeFlag = ""
                                            let params = this.getOpenCardLocationParams(QueryOpenCardData.data, "rechargeAmount");
                                            // 提交
                                            let DosubmitData = await Dosubmits({
                                                ...params,
                                                systemId: "3", //PC开卡
                                                identityKind: "1", //证件类型
                                                cardOutdex: CardOutdexData, //反面(这参数为身份证反面改为合拍的照片路径)
                                                sign: QuerySignData.data.sign, //提交加密的加密串
                                                timestamp: QuerySignData.data.timestamp, //提交加密接口的时间戳
                                                netSignUrl: QueryOpenCardData.data.netSignUrl,  //签名图片地址
                                                custPhoto: GetSimpleOrCardNumData.data.simple.image, //人脸
                                                cardIndex: GetSimpleOrCardNumData.data.cardNum.front, //正面
                                                custAddress: GetSimpleOrCardNumData.data.cardNum.address, //地址
                                                customerName: GetSimpleOrCardNumData.data.cardNum.confirmName, //姓名
                                                identityCode: GetSimpleOrCardNumData.data.cardNum.confirmIdcardNumber, //证件号码
                                            })

                                            if (DosubmitData.code == 0) {
                                                // 实名认证查询结束
                                                this.showToast(DosubmitData.msg);
                                                this.active = 0
                                                localStorage.removeItem("paynum")
                                                localStorage.removeItem("BizNo")
                                                localStorage.removeItem("uimId")
                                                localStorage.removeItem("GetToken")
                                                localStorage.removeItem("Judge")
                                            } else if (DosubmitData.code == -2) {
                                                localStorage.setItem("Judge", false) //实名查询禁止
                                                this.active = 0
                                            } else {
                                                localStorage.setItem("Judge", false) //实名查询禁止
                                                this.showToast(DosubmitData.msg);
                                            }
                                        }
                                    }
                                } else {
                                    localStorage.setItem("Judge", false) //实名查询禁止
                                    // 录制视频失败后success不等于0时的判断，并提示
                                    if (GetSimpleOrCardNumData.data.simple.success != 0) {
                                        this.showToast(GetSimpleOrCardNumData.data.simple.message);
                                    } else {
                                        this.showToast("人脸校验失败，请重新继续进行实名");
                                    }
                                }
                            } else {
                                localStorage.setItem("Judge", false) //实名查询禁止
                                // 录入身份证失败后success不等于0时的判断，并提示
                                if (GetSimpleOrCardNumData.data.cardNum.success != 0) {
                                    this.showToast(GetSimpleOrCardNumData.data.cardNum.message);
                                } else {
                                    this.showToast("身份校验失败，请重新继续进行实名");
                                }
                            }
                        }
                    } catch (err) {
                        localStorage.setItem("Judge", false); // 实名查询禁止
                        console.error("获取位置信息失败:", err.message || err);
                    }
                }
            } else {
                console.log("认证失败")
                localStorage.setItem("Judge", false)
            }
        },

        // 获取用户拍摄的照片
        ImgsBase64(message) {
            this.TogetherImgsData = message
        },

        showToast(message, position = "bottom", duration = 1100) {
            Toast({
                message,
                position,
                duration,
            });
        },
    },

    watch: {},

    computed: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
@import "../../assets/css/openCardScss/openCard.scss";
</style>
<style>
.van-checkbox__icon {
    font-size: 30px;
}
</style>